import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [time, setTime] = useState(new Date());
  
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);
    
    return () => {
      clearInterval(timer);
    };
  }, []);
  
  // 시계 바늘 각도 계산
  const seconds = time.getSeconds();
  const minutes = time.getMinutes();
  const hours = time.getHours() % 12;
  
  const secondsDegrees = seconds * 6; // 초당 6도 (360도 / 60초)
  const minutesDegrees = minutes * 6 + seconds * 0.1; // 분당 6도 + 초의 영향
  const hoursDegrees = hours * 30 + minutes * 0.5; // 시간당 30도 + 분의 영향
  
  return (
    <div className="app-container">
      {/* 배경 장식 요소들 */}
      <div className="background-decorations">
        <div className="bg-circle bg-circle-1"></div>
        <div className="bg-circle bg-circle-2"></div>
        <div className="bg-circle bg-circle-3"></div>
      </div>
      
      <div className="clock-container">
        {/* 시계 테두리 밖 장식 */}
        <div className="clock-outer-decoration"></div>
        
        {/* 시계 본체 */}
        <div className="clock-body">
          {/* 기울어진 시계판 효과 */}
          <div className="clock-face"></div>
          
          {/* 배경 이미지 */}
          <div className="clock-background">
            {/* 이미지 대신 그라데이션 배경 사용 */}
            <div className="bg-gradient"></div>
            {/* 어두운 오버레이로 대비 개선 */}
            <div className="dark-overlay"></div>
          </div>
          
          {/* 시계 내부 패턴 */}
          <div className="clock-pattern"></div>
          
          {/* SVG 시계 */}
          <svg 
            className="clock-svg"
            viewBox="0 0 600 600"
          >
            {/* 시계판 안쪽 장식 원 */}
            <circle
              cx="300"
              cy="300"
              r="100"
              fill="none"
              stroke="#ffffff"
              strokeWidth="2"
              strokeDasharray="3,7"
              opacity="0.6"
            />
            
            {/* 시간 표시 */}
            {[...Array(12)].map((_, i) => {
              const angle = (i * 30) - 90;
              const isSpecial = i % 3 === 0; // 3, 6, 9, 12는 특별하게
              const radius = isSpecial ? 85 : 90;
              const x = 300 + radius * Math.cos((angle * Math.PI) / 180);
              const y = 300 + radius * Math.sin((angle * Math.PI) / 180);
              
              return (
                <g key={i}>
                  {isSpecial ? (
                    // 특별한 시간 표시 (큰 숫자)
                    <text 
                      x={x}
                      y={y}
                      textAnchor="middle"
                      dominantBaseline="middle"
                      fill="#FFD700"
                      fontSize="22"
                      fontWeight="bold"
                      stroke="#000"
                      strokeWidth="0.5"
                      paintOrder="stroke"
                    >
                      {i === 0 ? 12 : i}
                    </text>
                  ) : (
                    // 일반 시간 표시 (작은 점)
                    <circle
                      cx={x}
                      cy={y}
                      r="4"
                      fill="#FF9EDB"
                      stroke="#000"
                      strokeWidth="0.5"
                    />
                  )}
                </g>
              );
            })}
            
            {/* 시침 - 색상 변경 */}
            <g transform={`rotate(${hoursDegrees}, 300, 300)`}>
              <path
                d="M300,300 L307,235 L300,220 L293,235 Z"
                fill="#FF9E7A" 
                stroke="#FF7E5A"
                strokeWidth="1.5"
                filter="drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.5))"
              />
              <circle cx="300" cy="240" r="4" fill="#FF9E7A" stroke="#000" strokeWidth="0.5" />
            </g>
            
            {/* 분침 - 색상 변경 */}
            <g transform={`rotate(${minutesDegrees}, 300, 300)`}>
              <path
                d="M300,300 L305,215 L300,200 L295,215 Z"
                fill="#7AFFDE" 
                stroke="#58EBC7"
                strokeWidth="1.5"
                filter="drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.5))"
              />
              <circle cx="300" cy="220" r="3" fill="#7AFFDE" stroke="#000" strokeWidth="0.5" />
            </g>
            
            {/* 초침 - 거품/물결 효과 추가 */}
            <g transform={`rotate(${secondsDegrees}, 300, 300)`} filter="drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.7))">
              {/* 초침 메인 라인 */}
              <line
                x1="300"
                y1="320"
                x2="300"
                y2="150"
                stroke="#FF6B6B"
                strokeWidth="3"
                strokeLinecap="round"
              />
              
              {/* 초침 돌출 부분 (테두리 밖으로 확실히 나감) */}
              <line
                x1="300"
                y1="150"
                x2="300"
                y2="50" 
                stroke="#FF6B6B"
                strokeWidth="3"
                strokeLinecap="round"
              />
              
              {/* 초침 끝 장식 */}
              <circle
                cx="300"
                cy="50"
                r="5"
                fill="#FF6B6B"
                stroke="#000"
                strokeWidth="0.5"
              />
              
              {/* 물결/거품 효과 - 초침 끝에서 퍼지는 동심원들 */}
              <circle
                cx="300"
                cy="50"
                r={10 + (seconds % 5) * 2}
                fill="none"
                stroke="#FF9999"
                strokeWidth="1.5"
                opacity={0.8 - (seconds % 5) * 0.1}
              />
              <circle
                cx="300"
                cy="50"
                r={15 + (seconds % 7) * 2}
                fill="none"
                stroke="#FF9999"
                strokeWidth="1"
                opacity={0.7 - (seconds % 7) * 0.05}
              />
              <circle
                cx="300"
                cy="50"
                r={20 + (seconds % 9) * 2}
                fill="none"
                stroke="#FF9999"
                strokeWidth="1"
                opacity={0.5 - (seconds % 9) * 0.02}
              />
              
              {/* 비눗방울 효과 - 작은 원들 */}
              {[...Array(5)].map((_, i) => {
                const angle = (seconds * 30 + i * 72) % 360;
                const distance = 15 + (i * 5);
                const x = 300 + distance * Math.cos(angle * Math.PI / 180);
                const y = 50 + distance * Math.sin(angle * Math.PI / 180);
                
                return (
                  <circle
                    key={i}
                    cx={x}
                    cy={y}
                    r={2 + Math.sin(seconds * 0.2 + i) * 1}
                    fill="#FFC2C2"
                    stroke="#FF6B6B"
                    strokeWidth="0.5"
                    opacity={0.8 - i * 0.1}
                  />
                );
              })}
              
              {/* 초침 카운터웨이트 */}
              <circle
                cx="300"
                cy="320"
                r="8"
                fill="#FF6B6B"
                stroke="#000"
                strokeWidth="0.5"
                opacity="0.9"
              />
            </g>
            
            {/* 시계 중앙 장식 */}
            <circle cx="300" cy="300" r="12" fill="#6930C3" />
            <circle cx="300" cy="300" r="8" fill="#5E60CE" />
            <circle cx="300" cy="300" r="4" fill="#5390D9" />
            <circle cx="300" cy="300" r="2" fill="#FFFFFF" />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default App;